module.exports = __webpack_public_path__ + "static/img/03_ava_recipe_cornelius_carstens.4caea83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/ava/03_ava_recipe_cornelius_carstens.png
// module id = ldro
// module chunks = 1